import type { ErrorComponentProps } from '@tanstack/react-router';
import { Button } from '@ui';

/** Detect the #1 prod CSR error: a stale chunk after a redeploy (ARCHITECTURE §6). */
function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /dynamically imported module|module script failed|ChunkLoadError|Failed to fetch/i.test(
    message,
  );
}

export function RouteErrorComponent({ error, reset }: ErrorComponentProps) {
  const chunk = isChunkLoadError(error);
  return (
    <div role="alert" className="grid h-full place-items-center p-6 text-center">
      <div className="max-w-md">
        <h2 className="text-lg font-semibold text-fg">
          {chunk ? 'A new version is available' : 'Something went wrong'}
        </h2>
        <p className="mt-1 text-sm text-muted">
          {chunk
            ? 'Reload the page to get the latest version.'
            : 'An unexpected error occurred while loading this view.'}
        </p>
        <div className="mt-4 flex justify-center gap-2">
          {chunk ? (
            <Button onClick={() => window.location.reload()}>Reload</Button>
          ) : (
            <Button onClick={reset}>Try again</Button>
          )}
        </div>
      </div>
    </div>
  );
}
